// Card copy rounds up so a displayed time is never shorter than the real one
const formatDriveTime = (minutes?: number | null): string | null => {
  if (!minutes || minutes <= 0) return null

  const rounded = Math.ceil(minutes / 5) * 5
  const hours = Math.floor(rounded / 60)
  const remainder = rounded % 60

  const parts = []
  if (hours > 0) parts.push(`${hours}h`)
  if (remainder > 0) parts.push(`${remainder}m`)

  return `${parts.join(' ')} drive`
}

export default formatDriveTime
